import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {ListItemIcon, ListItemText} from "@mui/material";
import {InfoRounded} from "@mui/icons-material";

const ITEM_HEIGHT = 48;


export default function TaskMenu({onDelete,onEdit,onView,onAssign,onMove,extra}) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };
    const handleDelete = (event) => {
        handleClose(event);
        onDelete();
    };
    const handleEdit = (event) => {
        handleClose(event);
        onEdit();
    };
    const handleView = (event) => {
        handleClose(event);
        if(onView) {
            onView();
        }
    };
    const handleMove = (event) => {
        handleClose(event);
        if(typeof onMove === 'function') {
            onMove();
        }

    };
    const handleAssign = (event) => {
        handleClose(event);
        onAssign();
    };  
    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {extra?.filter(v=>v)?.map(v=><MenuItem
                sx={{
                    textTransform: "capitalize"
                }}
                onClick={(event) => {
                    handleClose(event);
                    if (v.onClick && typeof v.onClick === 'function') {
                        v.onClick();
                    }
                }}>
                    {/*<ListItemIcon>*/}
                        {/*{v.icon ?? <InfoRounded fontSize="small"/>}*/}
                    {/*</ListItemIcon>*/}
                    {`${v.label}`.toLowerCase()}
                </MenuItem>)}
                {typeof onDelete === 'function' && <MenuItem onClick={handleDelete}>
                    Delete
                </MenuItem>}
                {typeof onEdit === 'function' && <MenuItem onClick={handleEdit}>
                    Edit
                </MenuItem>}
                {onView ? <MenuItem onClick={handleView}>
                   View
                </MenuItem> : null}
                {onMove ? <MenuItem onClick={handleMove}>
                   Move
                </MenuItem> : null}
                {typeof onAssign === 'function' && <MenuItem onClick={handleAssign}>
                    Assign
                </MenuItem>}
            </Menu>
        </div>
    );
}
